$(function() {

    /**
     * Testimonials
     * https://github.com/kenwheeler/slick/
     */
    $('.testimonials').slick({
        arrows: false,
        fade: true,
        autoplay: true,
        autoplaySpeed: 3000,
        pauseOnHover: false,
        pauseOnFocus: false
    });

    $('.photo-gallery .slides').slick({
        autoplay: false,
        autoplaySpeed: 3300,
        arrows: false,
        speed: 0,
        dots: false,
        infinite: true,
        slidesToShow: 4, 
        slidesToScroll: 4,
        cssEase: 'linear',
        pauseOnHover: false,
        pauseOnFocus: false,
        swipe: false,
        touchMove: false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          }
        ]
    });

    setInterval(function() {
        $('.photo-gallery .slides .slick-slide').addClass('leaving');

        setTimeout(function() {
            $('.photo-gallery .slides').slick('slickNext');
            $('.photo-gallery .slides .slick-slide').removeClass('leaving');
        }, 500);
    }, 3300);
    
    /**
     * Disable form submit buttons on submission
     */
    $('form').on('submit', function(e) {
        $('button[type="submit"]').prop('disabled', true);
    });

    /**
     * Scroll to element
     */
    $('.nav a').on('click', function(e) {
        var element = $(this).attr('href');
        if (! element.startsWith('#')) {
            return;
        }

        var target = $(element);
        if (target.length) {
            e.preventDefault();
            
            var headerHeight = $('.app-header').outerHeight();

            slideout.close();
            
            $('html, body').animate({
                scrollTop: target.offset().top - headerHeight
            }, 'slow');
        } else {
            window.location = '/' + element;
        }
    });

    /**
     * Contact form
     */
    if ($('#contact-form-btn').length) {
        $('#contact-form form').on('submit', function(e) {
            e.preventDefault();
            ajaxForm($(this));
        });

        $('.trigger-contact-form').on('click', function(e) {
            e.preventDefault();
            $('#contact-form').toggleClass('active');
        });

        /**
         * Contact Us button
         */
        window.initialContactUsButtonTop = $('#contact-form-btn').offset().top;
        setupContactUsButton();
        $(window).scroll(function() {
            setupContactUsButton();
        });

    }
});

/**
 * Slideout Nav
 * https://github.com/mango/slideout
 */
var slideout = new Slideout({
    'panel': document.getElementById('app-panel'),
    'menu': document.getElementById('app-nav-mobile'),
    'padding': 320,
    'tolerance': 70,
    'side': 'right',
    'touch': false
});

document.querySelector('.nav-icon').addEventListener('click', function() {
    slideout.toggle();
});

document.querySelector('#app-nav-mobile .close-icon').addEventListener('click', function() {
    slideout.close();
});

/**
 * Mask phone inputs
 */
Array.from(document.querySelectorAll('input[type="tel"]')).forEach(function(el) {
    new Cleave(el, {
        numericOnly: true,
        blocks: [0, 3, 0, 3, 4],
        delimiters: ["(", ")", " ", "-"],
    });
});

/**
 * Numeric inputs
 */
Array.from(document.querySelectorAll('input.numeric, input.currency, input.percentage')).forEach(function(el) {
    new Cleave(el, {
        numeral: true,
        numeralThousandsGroupStyle: 'thousand',
        numeralDecimalScale: 2
    });
});

/**
 * Setup the Contact Us button.
 */
function setupContactUsButton() {
    var scrollTop = $(window).scrollTop();
    var headerHeight = $('.app-header').outerHeight();
    
    if (! $('#contact-form-btn').is(':animated')) {

        if ((scrollTop + headerHeight) > window.initialContactUsButtonTop) {
            $('#contact-form-btn').addClass('fixed').css('top', headerHeight).css('bottom', 'auto');
        
        } else if (scrollTop < window.initialContactUsButtonTop) {
            $('#contact-form-btn').removeClass('fixed').css('top', 'auto').css('bottom', 0);
        }
    }
}
    
/**
 * WOW.js
 * Animate elements as they are scrolled into view
 * Don't forget to include https://github.com/daneden/animate.css
 * Instantiates only after the user starts scrolling as to 
 * not hide the elements from Googlebot.
 *
 * https://github.com/matthieua/WOW
 */
var scrolled = false;
$(window).on('scroll', function() {
    if (!scrolled) {
        scrolled = true;
        new WOW().init();
    }
});
